// Pseudo tiré au sort sur la landing (« Quel animal serez-vous ? »), transmis au formulaire d'inscription par
// sessionStorage (jamais par l'URL). Aucune réservation : le pseudo peut être pris avant l'inscription. Tout accès au
// stockage est protégé : navigation privée ou stockage bloqué ne doivent jamais faire échouer la page.
export const CHOSEN_PSEUDO_KEY = "paroles_agents_pseudo_choisi";

export function saveChosenPseudo({pseudo, emoji, couleur}) {
    try {
        sessionStorage.setItem(CHOSEN_PSEUDO_KEY, JSON.stringify({pseudo, emoji, couleur}));
    } catch {
        // stockage indisponible : le visiteur choisira son pseudo à l'inscription
    }
}

export function readChosenPseudo() {
    try {
        const stored = JSON.parse(sessionStorage.getItem(CHOSEN_PSEUDO_KEY));
        if (!stored || typeof stored.pseudo !== "string" || stored.pseudo === "" || stored.pseudo.length > 60) return null;
        if (typeof stored.emoji !== "string" || stored.emoji.length > 16) return null;
        if (typeof stored.couleur !== "string" || !/^#[0-9A-Fa-f]{6}$/.test(stored.couleur)) return null;
        return {pseudo: stored.pseudo, emoji: stored.emoji, couleur: stored.couleur};
    } catch {
        return null;
    }
}

export function clearChosenPseudo() {
    try {
        sessionStorage.removeItem(CHOSEN_PSEUDO_KEY);
    } catch {
        // rien à effacer
    }
}
